import { ampli } from "./generated/node";

// Initialise the node client on application load
if (process.env.AMPLITUDE_API_KEY) {
  ampli.load({ client: { apiKey: process.env.AMPLITUDE_API_KEY } });
}

export { ampli };
